import React, { useState } from 'react';
import './DetailsGridItem.css';
import FieldNames from '../../../defaults/FieldNames.json';
import { Avatar, Chip, Grid, Link } from '@mui/material';
import DetailsDatePicker from './DetailsDatePicker';
import DetailsSelect from './DetailsSelect';
import DetailsCheckbox from './DetailsCheckbox';
import DetailsNumber from './DetailsNumber';
import DetailsText from './DetailsText';
import DetailsTextArea from './DetailsTextArea';
import DetailsAutoComplete from './DetailsAutoComplete';
import fieldsDefinition from '../FieldInfo.json';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from "react-router-dom";
import { getConditionClassBasedOnDepartureIndex, getFieldDisplayValue, isFeaturePlannedOrActual, isFeaturePostFire } from '../../../utils/FeatureHelper';
import DetailsCurrency from './DetailsCurrency';
import ColorConstants from '../../../defaults/ColorConstants';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { currencyFormatWithDollar } from '../../../utils/FormatHelper';
import {checkYearIsFourDigits, formatDateForDisplay} from '../../../utils/DateHelper';
import DetailsYearPicker from './DetailsYearPicker';
import { useIFPRSGlobalContext } from '../../../IFPRSGlobalContext';
import { getByLevel } from '../../../utils/CategoryAssociationHelper';
import DetailsInteragency from './DetailsInteragency';
import {
  validateAgencyApprovalDate, validateCompletionDate,
  validateDepartmentApprovalDate, validateInitiationDate,
  validateLocalApprovalDate, validateRegionalApprovalDate
} from "../../../utils/ValidationHelper";


export default function DetailsActualsGridItem({ field, mode, actualsDetail, onFieldChange, getAllMissingFieldsCount, getAllUnsavedFieldsCount, getAllApprovalFieldsCount, 
  locationAgencyValue, setLocationAgencyValue, locationRegionValue, setLocationRegionValue, locationUnitValue, setLocationUnitValue, tribeNameValue, setTribeNameValue, setMode,
  classValue, setClassValue, categoryValue, setCategoryValue, isTreatment, plannedDetail, isCancelled, isWithinFiscalYear, onFiscalFieldChange, userInfo,
  userRoleInfo, departureIndexOptions, statusOptions, requiredFields, typeValue, setTypeValue, subTypeValue, setSubTypeValue, unitOfMeasureValue, setUnitOfMeasureValue, 
  setCostFundingPopoverOpen, setCostFundingPopoverUsePlannedActual, programValue, setProgramValue, interagencySelected, setInteragencySelected, 
  otherInteragencySelected, setOtherInteragencySelected
}) {
  const allFields = FieldNames.featureFields;
  const { categoryTypes} = useIFPRSGlobalContext();
  let fromPlanned = isTreatment ? FieldNames.actualTreatmentFromPlannedFields : FieldNames.actualActivityFromPlannedFields;
  // allow localID to be edited if progressive reporting is on
  if (isTreatment && actualsDetail?.attributes?.IsProgressiveReporting === FieldNames.yesNo.yes) {
    fromPlanned = fromPlanned.filter(f => f !== FieldNames.featureFields.localID);
  }
  const fieldIsStatic = isTreatment ? FieldNames.actualTreatmentStaticFields : FieldNames.actualActivityStaticFields;
  const currentfieldInfo = fieldsDefinition[field];
  const [isLocallyApproved, setIsLocallyApproved] = useState(false);
  const navigate = useNavigate();
  const costFields = FieldNames.actualActivityCostFields;


  const percentageFormat = (num) => {
    if(num){
      const trimmedNum = num.trim('\'');
      return trimmedNum + '%';
    } else {
      return '0%';
    }
  }

  const onManageCosts = () => {
    setCostFundingPopoverOpen(true);
    setCostFundingPopoverUsePlannedActual(false);
  }

  const getReadOnlyString = (fieldName) => {
    let completeDetails = actualsDetail;
    const isPostFire = isFeaturePostFire(completeDetails?.attributes);
    if(completeDetails && completeDetails.attributes){
      let finalValue = completeDetails.attributes[fieldName] ?? "--";
      if(currentfieldInfo && currentfieldInfo.name === FieldNames.featureFields.id){
        let idField = FieldNames.featureFields.id;
        finalValue = completeDetails.attributes[idField];
      } else {
        if (fieldName === allFields.isFunded) {
          if (completeDetails.attributes[fieldName] === FieldNames.yesNo.yes) {
            finalValue = FieldNames.yesNo.yes
          } else {
            finalValue = FieldNames.yesNo.no
          }
        } else if(fieldName === allFields.vegDeparturePercentageManual) {
          finalValue = getConditionClassBasedOnDepartureIndex(completeDetails.attributes[fieldName]);
        } else if (fieldName === allFields.initiationDate ||
          fieldName === allFields.completionDate ||
          fieldName === allFields.localApprovalDate ||
          fieldName === allFields.agencyApprovalDate ||
          fieldName === allFields.departmentApprovalDate ||
          fieldName === allFields.regionalApprovalDate ||
          fieldName === allFields.cancelledDate ||
          fieldName === allFields.createdOnDate ||
          fieldName === allFields.lastModifiedDate) {
          finalValue = completeDetails.attributes[fieldName] ? formatDateForDisplay(completeDetails.attributes[fieldName]) : "--/--/----";
        }
        else if (fieldName === allFields.parentID) {
          finalValue = <Link onClick={() => parentRedirect(completeDetails.attributes[fieldName], FieldNames.modes.read, allFields, completeDetails)}><span className='pointer'>{completeDetails.attributes[fieldName]}</span></Link>
        } else if(fieldName === allFields.wbsID && completeDetails.attributes[fieldName] === "XXXXXXXXXXXX") {
          finalValue = "--";
        }
        else if(fieldName === allFields.wbsID && completeDetails.attributes[FieldNames.featureFields.fundingAgency] && completeDetails.attributes[fieldName]
          && completeDetails.attributes[FieldNames.featureFields.fundingAgency].includes(FieldNames.agencies.blm)
          && completeDetails.attributes[FieldNames.featureFields.wbsID].length === 4
        ) {
          finalValue = "LF.HF." + completeDetails.attributes[fieldName] + "0000";
        } else if(fieldName === FieldNames.featureFields.interagencySupport) {
          if(isPostFire || (!isPostFire && completeDetails?.attributes[FieldNames.featureFields.isInteragency] !== FieldNames.yesNo.yes)){
            finalValue = '';
          } else {
            if(completeDetails.attributes[FieldNames.featureFields.interagencyName]){
              finalValue = completeDetails.attributes[FieldNames.featureFields.interagencyName]?.split('|')?.sort((a, b) => (a > b) ? 1 : -1)?.join(', ');
            } else {
              finalValue = '--'
            }
          }
        } else if(fieldName === allFields.estimatedSuccessProbability) {
          if(completeDetails && completeDetails.attributes && completeDetails.attributes[fieldName]){
            finalValue = completeDetails.attributes[fieldName].replace(/'/g,'');
          } else {
            finalValue = completeDetails.attributes[fieldName];
          }
          finalValue = percentageFormat(finalValue)
        } else if(fieldName === allFields.fundingDepartment || fieldName === allFields.fundingAgency ||
          fieldName === allFields.fundingRegion || fieldName === allFields.fundingUnit ||
          fieldName === allFields.fundingSubUnit || fieldName === allFields.fundingUnitType ||
          fieldName === allFields.fundingSource || fieldName === allFields.fundingSourceProgram ||
          fieldName === allFields.fundingSourceCategory || fieldName === allFields.fundingSourceSubCategory ||
          fieldName === allFields.fundingTribe){
          finalValue = getFieldDisplayValue(completeDetails.attributes[fieldName], fieldName, allFields);
        } else if(fieldName === allFields.estimatedTotalCost) {
          finalValue = currencyFormatWithDollar(completeDetails.attributes[fieldName])
        } else if (currentfieldInfo?.domain && currentfieldInfo?.domain.codedValues) {
          const codes = currentfieldInfo?.domain.codedValues;
          codes.forEach((element) => {
            if (actualsDetail.attributes[fieldName] === element.code) {
              finalValue = element.name;
            }
          })
        } else if(fieldName === "ManageCosts"){
          finalValue = (
            <div className="list-item-incident-name-vir">
              <Chip
              className="required-field-status-chip"
              onClick={() => onManageCosts()}
              avatar={<Avatar style={{fontSize: "12px", width: "22px", height: "22px", backgroundColor: ColorConstants.AvatarColor, color: ColorConstants.WhiteAlien }}><AttachMoneyIcon /></Avatar>}
              label={<span style={{fontSize: "12px", lineHeight: "21px"}}>View Actual Costs</span>} />
            </div>
          )
        } else {
          finalValue = completeDetails.attributes[fieldName];
        }
      }
      return finalValue;
    } else {
      return '';
    }
  }

  const parentRedirect = (objectId, modeState, allFields, details) => {
    const isPostFire = isFeaturePostFire(details);
    const isActual = isFeaturePlannedOrActual(false, details, FieldNames.featureFields);
    const entityStringValue = isPostFire ? "pf" : "f";
    if((details.attributes[allFields.isParentTreatment] && 
      details.attributes[allFields.isParentTreatment] === 'Yes') || isTreatment){
      navigate(`/${entityStringValue}/treatments/${objectId}`, {isActual: isActual});
    } else {
      navigate(`/${entityStringValue}/activities/${objectId}`, {isActual: isActual})
    }
    setMode(modeState);
  }

  const isFieldLockedDown = (field, detail) => {
    if(!field || !detail?.attributes)
    {
      // Some sort of error, so don't lock down field by accident
      return false;
    }
    return (
      (field === FieldNames.featureFields.department && detail.attributes[FieldNames.featureFields.locationDepartmentLocked] === FieldNames.yesNo.yes) 
      || (field === FieldNames.featureFields.agency && detail.attributes[FieldNames.featureFields.locationAgencyLocked] === FieldNames.yesNo.yes) 
      || (field === FieldNames.featureFields.region && detail.attributes[FieldNames.featureFields.locationRegionLocked] === FieldNames.yesNo.yes) 
      || (field === FieldNames.featureFields.unit && detail.attributes[FieldNames.featureFields.locationUnitLocked] === FieldNames.yesNo.yes) 
    )
  }

  const getEditControlForField = (fieldInfo) => {
    if (fieldInfo) {
      let actualFields = fieldsDefinition[fieldInfo.name];
      if(currentfieldInfo && (currentfieldInfo.name === FieldNames.featureFields.id)){
        let idField = FieldNames.featureFields.id;
        actualFields = fieldsDefinition[idField];
        if(actualsDetail && actualsDetail.attributes){
          if (!actualsDetail.attributes[idField]) {
            let id = uuidv4();
            actualsDetail.attributes[FieldNames.featureFields.entityId] = id;
          }
          return (
            actualsDetail.attributes[idField]
          )
        } else {
          return (
            "--"
          )
        }
      } else {
        if(actualFields){
          if (fieldInfo.name === FieldNames.legacyIDFields.actualTreatmentID || fieldInfo.name === FieldNames.legacyIDFields.actualActivityID || 
            fieldInfo.name === FieldNames.legacyIDFields.treatmentID || fieldInfo.name === FieldNames.legacyIDFields.activityID) {
            let idField = FieldNames.featureFields.id;
            if(actualsDetail && actualsDetail.attributes){
              if (!actualsDetail.attributes[idField]) {
                let id = uuidv4();
                actualsDetail.attributes[FieldNames.featureFields.entityID] = id;
              }
            }
            return (
              <DetailsText
                detail={actualsDetail}
                field={actualFields ? actualFields: field}
                onFieldChange={onFieldChange}
                isRequired={requiredFields.includes(field)}
                fieldIsStatic={fieldIsStatic.includes(field)}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
              />
            )
          } else if (fieldInfo.name === allFields.interagencySupport) {
            if(actualsDetail?.attributes[FieldNames.featureFields.isInteragency] === FieldNames.yesNo.yes){
              return (
                <DetailsInteragency
                  detail={actualsDetail}
                  fieldInfo={fieldInfo}
                  field={field}
                  onFieldChange={null}
                  allFields={FieldNames.featureFields}
                  interagencySelected={interagencySelected}
                  setInteragencySelected={setInteragencySelected}
                  otherInteragencySelected={otherInteragencySelected}
                  setOtherInteragencySelected={setOtherInteragencySelected}
                  itemsToDelete={null}
                  setItemsToDelete={null}
                  userInfo={userInfo}
                  isDisabled={true}
                />
              )
            } else {
              return ('')
            }
          } else if (fieldInfo.name === allFields.isFunded) {
            return (
              <DetailsCheckbox
                detail={actualsDetail}
                field={field}
                onFieldChange={onFieldChange}
                allFields={allFields}
              />
            )
          } else if(fieldInfo.name === allFields.vegDeparturePercentageManual) {
            return (
              <DetailsSelect
                detail={actualsDetail}
                field={field}
                onFieldChange={onFieldChange}
                fieldInfo={fieldInfo}
                isRequired={requiredFields.includes(field)}
                allFields={allFields}
                fieldIsStatic={fieldIsStatic.includes(field)}
                classValue={classValue}
                setClassValue={setClassValue}
                categoryValue={categoryValue}
                setCategoryValue={setCategoryValue}
                unitOfMeasureValue={unitOfMeasureValue}
                setUnitOfMeasureValue={setUnitOfMeasureValue}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                fundingSourceOptions={null}
                departureOptions={departureIndexOptions}
                statusOptions={statusOptions}
                isActuals={true}
                typeValue={typeValue}
                setTypeValue={setTypeValue}
                subTypeValue={subTypeValue}
                setSubTypeValue={setSubTypeValue}
                agencyValue={actualsDetail && actualsDetail.attributes ? actualsDetail.attributes[allFields.fundingAgency] : ''}
                locationDepartmentValue={""}
                setLocationDepartmentValue={null}
                programValue={programValue}
                setProgramValue={setProgramValue}
              />
            )
          } else if(fieldInfo.name === FieldNames.featureFields.measureAmount){
            const isPostFire = isFeaturePostFire(actualsDetail.attributes)
            if(isPostFire){
              return (
                <DetailsNumber
                  detail={actualsDetail}
                  field={field}
                  onFieldChange={onFieldChange}
                  isRequired={requiredFields.includes(field)}
                  fieldIsStatic={fieldIsStatic.includes(field)}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  max={400}
                  min={0}
                />
              )
            } else {
              return ('')
            }
          } else if (fieldInfo.name === allFields.notes || fieldInfo.name === allFields.statusReason || fieldInfo.name === allFields.contributedNotes) {
            return (
              <DetailsTextArea
                detail={actualsDetail}
                field={field}
                onFieldChange={onFieldChange}
                isRequired={requiredFields.includes(field)}
                fieldIsStatic={fieldIsStatic.includes(field)}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                isActuals={true}
                plannedFeature={plannedDetail}
              />
            )
          } else if(fieldInfo.name === allFields.agency){
            if(actualsDetail && actualsDetail.attributes){
              const isEditable = !isFieldLockedDown(field, actualsDetail);
              if(isEditable){
                return (
                  <DetailsAutoComplete 
                    userInfo={userInfo}
                    field={field}
                    parentValue={null}
                    selectionValue={locationAgencyValue}
                    setSelectionValue={setLocationAgencyValue}
                    userRoleInfo={userRoleInfo}
                    onFieldChange={onFieldChange}
                    detail={actualsDetail}
                    isRequired={requiredFields.includes(field)}
                  />
                )
              } else {
                return (
                  <DetailsText 
                    detail={actualsDetail}
                    field={field}
                    onFieldChange={onFieldChange}
                    isRequired={requiredFields.includes(field)}
                    fieldIsStatic={true}
                    getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                    selectionValue={tribeNameValue}
                  />
                )
              }
            }
          } else if(fieldInfo.name === allFields.region){
            if(actualsDetail && actualsDetail.attributes){
              const isEditable = !isFieldLockedDown(field, actualsDetail);
              if(isEditable){
                return (
                  <DetailsAutoComplete  
                    userInfo={userInfo}
                    field={field}
                    parentValue={null}
                    selectionValue={locationRegionValue}
                    setSelectionValue={setLocationRegionValue}
                    userRoleInfo={userRoleInfo}
                    onFieldChange={onFieldChange}
                    detail={actualsDetail}
                    isRequired={requiredFields.includes(field)}
                  />
                )
              } else {
                return (
                  <DetailsText 
                    detail={actualsDetail}
                    field={field}
                    onFieldChange={onFieldChange}
                    isRequired={requiredFields.includes(field)}
                    fieldIsStatic={true}
                    getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                    selectionValue={tribeNameValue}
                  />
                )
              }
            }
          }else if(fieldInfo.name === allFields.unit){
            if(actualsDetail && actualsDetail.attributes){
              const isEditable = !isFieldLockedDown(field, actualsDetail);
              if(isEditable){
                return (
                  <DetailsAutoComplete 
                    userInfo={userInfo} 
                    field={field}
                    parentValue={null}
                    selectionValue={locationUnitValue}
                    setSelectionValue={setLocationUnitValue}
                    userRoleInfo={userRoleInfo}
                    onFieldChange={onFieldChange}
                    detail={actualsDetail}
                    isRequired={requiredFields.includes(field)}
                  />
                )
              } else {
                return (
                  <DetailsText
                    detail={actualsDetail}
                    field={field}
                    onFieldChange={onFieldChange}
                    isRequired={requiredFields.includes(field)}
                    fieldIsStatic={true}
                    getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                    selectionValue={tribeNameValue}
                  />
                )
              }
            }
          }
          else if(fieldInfo.name === allFields.tribeName){
            if(actualsDetail && actualsDetail.attributes){
              return (
                <DetailsAutoComplete 
                  userInfo={userInfo} 
                  field={field}
                  parentValue={null}
                  selectionValue={tribeNameValue}
                  setSelectionValue={setTribeNameValue}
                  userRoleInfo={userRoleInfo}
                  onFieldChange={onFieldChange}
                  detail={actualsDetail}
                  isRequired={requiredFields.includes(field)}
                />
              )
            }
          }
           else if (fieldInfo.name === allFields.initiationDate || 
            fieldInfo.name === allFields.completionDate || 
            fieldInfo.name === allFields.createdOnDate ||
            fieldInfo.name === allFields.lastModifiedDate) {
            const validators = {
              [FieldNames.featureFields.initiationDate ]: [
                checkYearIsFourDigits,
                validateInitiationDate
              ],
              [FieldNames.featureFields.completionDate]: [
                checkYearIsFourDigits,
                validateCompletionDate
              ],

            }
            return (
              <DetailsDatePicker
                detail={actualsDetail}
                field={field}
                validators={validators[fieldInfo.name]}
                onFieldChange={onFieldChange}
                isLocallyApproved={false}
                setIsLocallyApproved={null}
                isRegionalApproved={false}
                setIsRegionalApproved={null}
                isAgencyApproved={false}
                setIsAgencyApproved={null}
                isDepartmentApproved={false}
                setIsDepartmentApproved={null}
                isRequired={requiredFields.includes(field)}
                getAllMissingFieldsCount={getAllMissingFieldsCount}
                allFields={allFields}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                isPast={true}
                userInfo={userInfo}
                userRoleInfo={userRoleInfo}
                isCancelled={isCancelled}
                isWithinFiscalYear={isWithinFiscalYear}
                onFiscalFieldChange={onFiscalFieldChange}
                isActuals={true}
                isTreatment={isTreatment}
              />
            )
          } else if(fieldInfo.name === allFields.obligationFiscalYear){
            return (
              <DetailsYearPicker
                detail={actualsDetail}
                field={field}
                onFieldChange={onFieldChange}
                isRequired={requiredFields.includes(field)}
                allFields={allFields}
                isActuals={true}
              />
            )
          } else if (fieldInfo.name === allFields.localApprovalDate ||
            fieldInfo.name === allFields.agencyApprovalDate ||
            fieldInfo.name === allFields.departmentApprovalDate ||
            fieldInfo.name === allFields.regionalApprovalDate) {

             const validators = {
              [FieldNames.featureFields.localApprovalDate]: [
                  checkYearIsFourDigits,
                  validateLocalApprovalDate
              ],
              [FieldNames.featureFields.agencyApprovalDate]: [
                  checkYearIsFourDigits,
                  validateAgencyApprovalDate
              ],
              [FieldNames.featureFields.departmentApprovalDate]: [
                  checkYearIsFourDigits,
                validateDepartmentApprovalDate
              ],
              [FieldNames.featureFields.regionalApprovalDate]: [
                  checkYearIsFourDigits,
                  validateRegionalApprovalDate
              ]
            }

            return (
              <DetailsDatePicker
                detail={actualsDetail}
                field={field}
                validators={validators[fieldInfo.name]}
                onFieldChange={onFieldChange}
                isLocallyApproved={isLocallyApproved}
                setIsLocallyApproved={setIsLocallyApproved}
                isRegionalApproved={false}
                setIsRegionalApproved={null}
                isAgencyApproved={false}
                setIsAgencyApproved={null}
                isDepartmentApproved={false}
                setIsDepartmentApproved={null}
                isRequired={requiredFields.includes(field)}
                getAllMissingFieldsCount={getAllMissingFieldsCount}
                allFields={allFields}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                isPast={false}
                userInfo={userInfo}
                userRoleInfo={userRoleInfo}
                isCancelled={isCancelled}
                isWithinFiscalYear={isWithinFiscalYear}
                onFiscalFieldChange={onFiscalFieldChange}
                isActuals={true}
                isTreatment={isTreatment}
              />
            )
          } else if (fieldInfo.name === allFields.durability) {
            return (
              <DetailsNumber
                detail={actualsDetail}
                field={field}
                onFieldChange={onFieldChange}
                isRequired={requiredFields.includes(field)}
                fieldIsStatic={fieldIsStatic.includes(field)}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
              />
            )
          } else if (fieldInfo.name === allFields.parentID) {
            if (actualsDetail?.attributes[fieldInfo.name]) {
              return (
                <Link onClick={() => parentRedirect(actualsDetail.attributes[fieldInfo.name], FieldNames.modes.read, allFields, actualsDetail)}><span className='pointer'>{actualsDetail.attributes[fieldInfo.name]}</span></Link>
              )
            } else {
              return (
                <span>--</span>
              )
            }
    
          } else if(fieldInfo.name === allFields.fundingDepartment || fieldInfo.name === allFields.fundingAgency || 
            fieldInfo.name === allFields.fundingRegion || fieldInfo.name === allFields.fundingUnit || 
            fieldInfo.name === allFields.fundingSource || fieldInfo.name === allFields.fundingSourceProgram ||
            fieldInfo.name === allFields.fundingSourceCategory || fieldInfo.name === allFields.fundingSourceSubCategory ||
            fieldInfo.name === allFields.fundingTribe || fieldInfo.name === allFields.fundingUnitType){
              const tempVal = getFieldDisplayValue(actualsDetail.attributes[field], fieldInfo.name, allFields);
            return (
              <DetailsText
                detail={actualsDetail}
                field={field}
                onFieldChange={onFieldChange}
                isRequired={requiredFields.includes(field)}
                fieldIsStatic={fieldIsStatic.includes(field)}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                selectionValue={tempVal}
              />
            )
          } else if (fieldInfo.name === allFields.department) {
            if(actualsDetail && actualsDetail.attributes){
              return (
                <DetailsSelect
                  detail={actualsDetail}
                  field={field}
                  onFieldChange={onFieldChange}
                  fieldInfo={fieldInfo}
                  isRequired={requiredFields.includes(field)}
                  allFields={allFields}
                  fieldIsStatic={fieldIsStatic.includes(field) || isFieldLockedDown(field, actualsDetail)}
                  classValue={classValue}
                  setClassValue={setClassValue}
                  categoryValue={categoryValue}
                  setCategoryValue={setCategoryValue}
                  unitOfMeasureValue={unitOfMeasureValue}
                  setUnitOfMeasureValue={setUnitOfMeasureValue}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  fundingSourceOptions={null}
                  departureOptions={null}
                  statusOptions={statusOptions}
                  isActuals={true}
                  typeValue={typeValue}
                  setTypeValue={setTypeValue}
                  subTypeValue={subTypeValue}
                  setSubTypeValue={setSubTypeValue}
                  agencyValue={actualsDetail && actualsDetail.attributes ? actualsDetail.attributes[allFields.fundingAgency] : ''}
                  locationDepartmentValue={""}
                  setLocationDepartmentValue={null}
                  programValue={programValue}
                  setProgramValue={setProgramValue}
                />
              )
            }
          } else if(fieldInfo.name === allFields.estimatedTotalCost) {
            return (
              <DetailsCurrency
                detail={actualsDetail}
                currencyValue={actualsDetail.attributes[field]}
                field={field}
                onFieldChange={onFieldChange}
                isRequired={requiredFields.includes(field)}
                getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                costFields={costFields}
              />
            )
          } else if(fieldInfo.name === allFields.type || fieldInfo.name === allFields.category || 
            fieldInfo.name === FieldNames.featureFields.unitOfMeasure
          ) {
            const isPostFire = isFeaturePostFire(actualsDetail.attributes)
            if(fieldInfo.name !== FieldNames.featureFields.unitOfMeasure || (isPostFire && fieldInfo.name === FieldNames.featureFields.unitOfMeasure)){
              return (
                <DetailsSelect
                  detail={actualsDetail}
                  field={field}
                  onFieldChange={onFieldChange}
                  fieldInfo={fieldInfo}
                  isRequired={requiredFields.includes(field)}
                  allFields={allFields}
                  fieldIsStatic={fieldIsStatic.includes(field)}
                  classValue={classValue}
                  setClassValue={setClassValue}
                  categoryValue={categoryValue}
                  setCategoryValue={setCategoryValue}
                  unitOfMeasureValue={unitOfMeasureValue}
                  setUnitOfMeasureValue={setUnitOfMeasureValue}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  fundingSourceOptions={null}
                  departureOptions={null}
                  statusOptions={statusOptions}
                  isActuals={true}
                  typeValue={typeValue}
                  setTypeValue={setTypeValue}
                  subTypeValue={subTypeValue}
                  setSubTypeValue={setSubTypeValue}
                  agencyValue={actualsDetail && actualsDetail.attributes ? actualsDetail.attributes[allFields.fundingAgency] : ''}
                  locationDepartmentValue={""}
                  setLocationDepartmentValue={null}
                  programValue={programValue}
                  setProgramValue={setProgramValue}
                />
              )
            } else {
              return ('')
            }
          } else if(fieldInfo.name === allFields.subType) {
            const subTypeActualPossibleValues = getByLevel(actualsDetail?.attributes, FieldNames.categoryAssociationFields.subTypes)
            const subTypePlannedPossibleValues = getByLevel(plannedDetail?.attributes, FieldNames.categoryAssociationFields.subTypes)
            if(subTypeActualPossibleValues?.length > 0 || subTypePlannedPossibleValues?.length > 0){
              return (
                <DetailsSelect
                  detail={actualsDetail}
                  field={field}
                  onFieldChange={onFieldChange}
                  fieldInfo={fieldInfo}
                  isRequired={requiredFields.includes(field)}
                  allFields={allFields}
                  fieldIsStatic={fieldIsStatic.includes(field) || ((!subTypeActualPossibleValues || subTypeActualPossibleValues?.length === 0))}
                  classValue={classValue}
                  setClassValue={setClassValue}
                  categoryValue={categoryValue}
                  setCategoryValue={setCategoryValue}
                  unitOfMeasureValue={unitOfMeasureValue}
                  setUnitOfMeasureValue={setUnitOfMeasureValue}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  fundingSourceOptions={null}
                  departureOptions={null}
                  statusOptions={statusOptions}
                  isActuals={true}
                  typeValue={typeValue}
                  setTypeValue={setTypeValue}
                  subTypeValue={subTypeValue}
                  setSubTypeValue={setSubTypeValue}
                  agencyValue={actualsDetail && actualsDetail.attributes ? actualsDetail.attributes[allFields.fundingAgency] : null}
                  locationDepartmentValue={""}
                  setLocationDepartmentValue={null}
                  programValue={programValue}
                  setProgramValue={setProgramValue}
                />
              )
            } else {
              return ("--")
            }
            
          } else if(fieldInfo.name === allFields.status) {
            return (
              <DetailsSelect
                detail={actualsDetail}
                  field={field}
                  onFieldChange={onFieldChange}
                  fieldInfo={fieldInfo}
                  isRequired={requiredFields.includes(field)}
                  allFields={allFields}
                  fieldIsStatic={fieldIsStatic.includes(field)}
                  classValue={classValue}
                  setClassValue={setClassValue}
                  categoryValue={categoryValue}
                  setCategoryValue={setCategoryValue}
                  unitOfMeasureValue={unitOfMeasureValue}
                  setUnitOfMeasureValue={setUnitOfMeasureValue}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  fundingSourceOptions={null}
                  departureOptions={null}
                  statusOptions={statusOptions}
                  isActuals={true}
                  typeValue={typeValue}
                  setTypeValue={setTypeValue}
                  subTypeValue={subTypeValue}
                  setSubTypeValue={setSubTypeValue}
                  agencyValue={actualsDetail && actualsDetail.attributes ? actualsDetail.attributes[allFields.fundingAgency] : ''}
                  locationDepartmentValue={""}
                  setLocationDepartmentValue={null}
                  programValue={programValue}
                  setProgramValue={setProgramValue}
              />
            )
          } else if(fieldInfo.name === "ManageCosts"){
            return (
              <div className="list-item-incident-name-vir">
                <Chip
                className="required-field-status-chip"
                onClick={() => onManageCosts()}
                avatar={<Avatar style={{fontSize: "12px", width: "22px", height: "22px", backgroundColor: ColorConstants.AvatarColor, color: ColorConstants.WhiteAlien }}><AttachMoneyIcon /></Avatar>}
                label={<span style={{fontSize: "12px", lineHeight: "21px"}}>View Actual Costs</span>} />
              </div>
            )
          } else {
            if (fieldInfo.domain) {
              return(
              <DetailsSelect
                detail={actualsDetail}
                  field={field}
                  onFieldChange={onFieldChange}
                  fieldInfo={fieldInfo}
                  isRequired={requiredFields.includes(field)}
                  allFields={allFields}
                  fieldIsStatic={fieldIsStatic.includes(field)}
                  classValue={classValue}
                  setClassValue={setClassValue}
                  categoryValue={categoryValue}
                  setCategoryValue={setCategoryValue}
                  unitOfMeasureValue={unitOfMeasureValue}
                  setUnitOfMeasureValue={setUnitOfMeasureValue}
                  getAllApprovalFieldsCount={getAllApprovalFieldsCount}
                  fundingSourceOptions={null}
                  departureOptions={null}
                  statusOptions={statusOptions}
                  isActuals={true}
                  typeValue={typeValue}
                  setTypeValue={setTypeValue}
                  subTypeValue={subTypeValue}
                  setSubTypeValue={setSubTypeValue}
                  agencyValue={actualsDetail && actualsDetail.attributes ? actualsDetail.attributes[allFields.fundingAgency] : ''}
                  locationDepartmentValue={""}
                  setLocationDepartmentValue={null}
                  programValue={programValue}
                  setProgramValue={setProgramValue}
              />
              )
            }
          }
        //}
        } else {
          return ("--")
        }
      }
    } 

    return (
      <DetailsText
        detail={actualsDetail}
        field={field}
        onFieldChange={onFieldChange}
        isRequired={requiredFields.includes(field)}
        fieldIsStatic={fieldIsStatic.includes(field)}
        getAllApprovalFieldsCount={getAllApprovalFieldsCount}
      />
    )
  }

  return (
    <Grid item size={12} container direction="column"
        className="grid-item" style={{ alignItems: 'left', paddingRight: '5px' }}>
        <Grid item size={12} style={{ padding: '5px 0 5px 0', whiteSpace: 'pre-wrap', wordWrap: 'break-word'}}>
          {(mode === FieldNames.modes.read) ? 
            ((actualsDetail && actualsDetail.attributes) ? getReadOnlyString(field) : '--') 
          : 
            ((currentfieldInfo && actualsDetail?.attributes && fromPlanned && !fromPlanned.includes(currentfieldInfo.name)) ? getEditControlForField(currentfieldInfo) : '--')}
        </Grid>
      </Grid>
  )
}
